import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';

import PatientFacing from './components/PatientFacing';
import enLocale from './locales/en';
import store from './store';

import './index.css';

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider messages={enLocale} locale="en">
      <PatientFacing />
    </IntlProvider>
  </Provider>,
  document.getElementById('root'),
);
